<div class="modal-header">
    <div>
        Location
    </div>
    <span (click)="cancel()" class="close ">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"
            width="26px" height="26px" fill="#fff">
            <path
                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" />
        </svg>
    </span>
</div>

<div class="pb-4">
    <mat-card class="p-0 pb-4">
        <div class="col-md-12 locWrapper">
            <div>
                <mat-card class="card mt-3">
                    <div class="row mr-0 ml-0">
                        <div class="col-md-4"> <span class="loc-label">Part No :</span> {{partNumber}}</div>
                        <div class="col-md-4"> <span class="loc-label">Serial No :</span> {{serialNumber}}</div>
                    </div>
                </mat-card>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-top-header">
                        <p class="float-left mt-1 m-0">Location</p>
                        <span class="float-right">
                            <input type="text" class= "mr-4" id="inputVal" placeholder="Search"
                                title="Type in a name" [(ngModel)]="searchInput" (keyup)="searching($event.target.value)">
                        </span>
                    </div>
                </div>
            </div>
            <div class="tableOverflow">
            <table matSort (matSortChange)="sortData($event)" class="table dt-table" id="dataTable" #TABLE> 
                <thead>
                    <tr>
                        <th>Select</th>
                        <th>S.No</th>
                        <th mat-sort-header="locationName">Location</th>
                        <th mat-sort-header="platformId">Platform</th>
                        <th mat-sort-header="operationStatus">Operational Status</th>
                        <th mat-sort-header="physicalAddress">Physical Address</th>
                        <th mat-sort-header="shippingAddress">Shipping Address</th>
                        <th mat-sort-header="phoneNo">Phone No</th>
                        <th mat-sort-header="website">Email</th>
                        <th mat-sort-header="addedOn">Added On </th>
                        <th mat-sort-header="updatedOn">Last Modified On </th>
                    </tr>
                </thead>
                <tbody class="locDataTable">
                    <tr *ngFor="let locationData of sortedData | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; let i = index ">
                        <td>
                            <mat-radio-group  [(ngModel)]="selectedLocation">
                                <mat-radio-button color="primary" [value]="locationData" [disabled]="role == 'DET_Readonly'"></mat-radio-button>
                            </mat-radio-group>
                        </td>
                        <td>{{(page-1) * pageSize + (i+1)}}</td>
                        <td>
                            {{locationData.locationName}}
                        </td>
                        <td>
                            <span *ngFor="let platform of platformData">
                                <span *ngIf="locationData.platformId == platform.platformId">{{platform.platform}}</span>
                            </span>
                        </td>
                        <td>
                            <span *ngFor="let status of status">
                                <span *ngIf="locationData.operationStatus == status.statusId">{{status.statusValue}}</span>
                            </span>
                        </td>
                        <td>
                            {{locationData.physicalAddress}}
                        </td>
                        <td>
                            {{locationData.shippingAddress}}
                        </td>
                        <td>
                            {{locationData.phoneNo}}
                        </td>
                        <td>
                            {{locationData.website}}
                        </td>
                        <td>{{locationData.addedOn | date : 'MM/dd/yyyy HH:mm:ss'}}</td>
                        <td>{{locationData.updatedOn | date : 'MM/dd/yyyy HH:mm:ss'}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <div class="row" *ngIf="sortedData.length">
                <div class="col-md-4 mt-3">
                    <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="sortedData.length"
                        [boundaryLinks]=true [maxSize]="3" [rotate]="true">
                    </ngb-pagination>
                </div>
                <div class="col-md-4 mt-3">
                    <div class="text-center count-indicator">Showing {{(page-1) * pageSize + 1}} -
                        {{endCount(page,pageSize,sortedData.length)}}
                        of {{sortedData.length}} entries</div>
                </div>
                <div class="col-md-4 text-right mt-3">
                    <select class="custom-select text-right" style="width: auto" [(ngModel)]="pageSizeCount" (ngModelChange)="setPageValue()">
                        <option [ngValue]="'page10'">View 10</option>
                        <option [ngValue]="'page20'">View 20</option>
                        <option [ngValue]="'pageAll'">View All</option>
                    </select>
                </div>
            </div>
            <div class="row m-0 mt-1" *ngIf="sortedData.length">
                <div class="col-md-12 p-0 text-right">
                    <button mat-raised-button class="mr-3 btn-cancel" (click)="cancel()">Cancel</button>
                    <button mat-raised-button class="btn-save" *ngIf="role != 'DET_Readonly'" (click)="saveLocation()">Save</button>
                </div>
            </div>
            <div *ngIf="sortedData.length == 0" class="no-data pb-2">
                No Data Available
            </div>
        </div>
    </mat-card>
</div>